document.addEventListener("DOMContentLoaded", () => {
	const subnavToggles = document.querySelectorAll("[data-submenu-toggle]");
	const subnavs = document.querySelectorAll(".subnav");
	const megaToggles = document.querySelectorAll("[data-mega-toggle]");
	const megas = document.querySelectorAll(".mega");
	const root = document.getElementById('root');

	subnavToggles.forEach((toggle) =>
		toggle.addEventListener("mouseover", () => {
			subnavToggles.forEach((t) => t.classList.remove("active"));
			subnavs.forEach((sub) => sub.classList.remove("subnav--active"));

			const wrap = toggle.closest(".nav__item");
			const subnav = wrap.querySelector(".subnav");
			const overlay = root.querySelector(':scope > .overlay-close');
      const subItems = subnav.querySelectorAll("[data-mega-toggle]");

			toggle.classList.add("active");
			subnav?.classList.add("subnav--active");

			if (subnav) {
				overlay.classList.add('active');
			}

      subItems.forEach((toggle, index) => {
        console.log('Toggle!', toggle, index);
        if (index === 0) {
        megaToggles.forEach((t) => t.classList.remove("active"));
        megas.forEach((mega) => mega.classList.remove("mega--active"));
        toggle.classList.add("active")
        const megaId = toggle.getAttribute("data-mega-toggle");
        const mega = wrap.querySelector(`#${megaId}`);
        mega?.classList.add("mega--active");
        } 
      });

			megaToggles.forEach((toggle) => {
        var timeoutId = null;
				toggle.addEventListener("mouseenter", () => {
          timeoutId = setTimeout(() => {
            megaToggles.forEach((t) => t.classList.remove("active"));
            megas.forEach((mega) => mega.classList.remove("mega--active"));

            const megaId = toggle.getAttribute("data-mega-toggle");

            const mega = wrap.querySelector(`#${megaId}`);
            toggle.classList.add("active");
            mega?.classList.add("mega--active");

            mega?.addEventListener("mouseleave", () => {
              mega.classList.remove("active");
              megaMenus.forEach((megaMenu) => megaMenu.classList.remove("mega-menu--active"));
            });
            }, 300);
				});
        toggle.addEventListener("mouseleave", () => {
          if (timeoutId) {
            clearTimeout(timeoutId);
            timeoutId = null;
          }
        });
			});

			wrap.addEventListener(
				"mouseleave",
				() => {
					toggle.classList.remove("active");
					subnav?.classList.remove("subnav--active");
					megaToggles.forEach((t) => t.classList.remove("active"));
					megas.forEach((mega) => mega.classList.remove("mega--active"));
					overlay.classList.remove('active');
				},
				{ once: true },
			);
		}),
	);
});
